
import { BackupRepoDto } from '@/services/Backup/interfaces';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';


@Component
export default class PruneBackupRepoDialog extends Vue {

  @Prop()
  public backupRepo!: BackupRepoDto;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to prune Backup Repository: #${this.backupRepo.id}?`;
  }

  public async pruneBackupRepository(): Promise<void> {
    this.$emit('prune', this.backupRepo);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
